import * as React from "react"
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    width={25.491}
    height="6.8mm"
    style={{
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd",
    }}
    viewBox="0 0 136789 137912"
    {...props}
  >
    <path
      d="M72927 71745c-6628-8549 5945-9587 2375-18257-2513-6099-3969 280-3961-9003 6-9334 1621-2884 4008-8944 789-2000 837-3639 67-5746-2191-5989-3840 2142-3963-14000l10151-67L81577 0 54840 49l73 15718 10058 18c0 1888 229 6881-136 8423-896 3786-2010 1750-3588 4938-3293 6665 3355 9068 3724 11974 1383 10857-2556 7924-4087 12988-2060 6817 3345 6768 4103 11479 1071 6651-4715 6539-4437 12510 300 6492 4368 2409 4439 11826l-9690-51-5758 28434 14872-6-5336 4529c-12968 8660-33419 19079-38240-4514l16929-183-6561-28195-25425-63L0 118306c18511-8 16065-1099 17756 3523 501 1369 718 2430 1286 3787 8928 21307 35334 7331 47046-2438 655 4719-574 11080 1025 14734 5402-1079 2821-3431 3334-14645l12219 7784c4655 2485 9253 4900 15388 5724 19678 2630 18135-15209 23169-18479l15566-44-6081-28360-25844 120-6009 28258 16732 30c-3931 19736-19620 15862-33075 7811-1241-743-9640-5839-10003-7265-85-329-332-355-478-550l15227-46-6074-28360-9731 25c79-10449 9524-7790 1474-18170z"
      style={{
        fill: "#130c0e",
      }}
      className="fill"
    />
  </svg>
)
export default SvgComponent
